import { use } from 'react';
import type { FeatureFlags } from '@a1/shared';
import FeatureFlagsContext from './FeatureFlagsContext';

interface UseFeatureFlags {
  (): FeatureFlags;
  (flag: keyof FeatureFlags): boolean;
}

const useFeatureFlags = ((flag?: keyof FeatureFlags) => {
  const flags = use(FeatureFlagsContext);
  return flag !== undefined ? flags[flag] : flags;
}) as UseFeatureFlags;

export default useFeatureFlags;
